<div class="form-group">
  <label class="fw-bold">{{ label }}</label>
  <div class="dropdown" [class.show]="isDropdownOpen">
    <div class="input-wrapper">
      <input
        type="text"
        [formControl]="inputFormControl"
        class="form-control"
        [class.is-invalid]="inputFormControl && inputFormControl.invalid && (inputFormControl.touched || inputFormControl.dirty)"
        [class.is-valid]="inputFormControl && inputFormControl.valid && (inputFormControl.touched || inputFormControl.dirty)"
        [readonly]="readonly"
        [placeholder]="placeholder"
        autocomplete="off"
        (input)="onInput($event)"
        #inputElement
        />
      <span class="search-icon">
        <i class="fa fa-search text-muted"></i>
      </span>
    </div>
    <div class="dropdown-container">
      @if (valueType === 'string') {
        <ul class="dropdown-menu w-100" [class.show]="isDropdownOpen && (preventAutoOpen === false)" (scroll)="onDropdownScroll($event)">
          @if (isLoading) {
            <li class="dropdown-item text-center p-2">
              <loader [config]="dropdownLoaderConfig"/>
            </li>
          }
          @if (filteredOptions.length === 0 && !isLoading) {
            <li class="dropdown-item text-muted">No options available</li>
          }
          @for (option of filteredOptions; track option) {
            <li (click)="onOptionSelect(option)" class="dropdown-item">
              {{ option.value }}
            </li>
          }
          @if (isLoadingMore) {
            <li class="dropdown-item text-center p-2">
              <loader [config]="dropdownLoaderConfig"/>
            </li>
          }
        </ul>
      }
      @if (valueType === 'number') {
        <ul class="dropdown-menu w-100" [class.show]="isDropdownOpen && (preventAutoOpen === false)" (scroll)="onDropdownScroll($event)">
          @if (isLoading) {
            <li class="dropdown-item text-center p-2">
              <loader [config]="dropdownLoaderConfig"/>
            </li>
          }
          @if (filteredOptions.length === 0 && !isLoading) {
            <li class="dropdown-item text-muted">No options available</li>
          }
          @for (option of filteredOptions; track option) {
            <li (click)="onOptionSelectNumber(option)" [id]="option.key" class="dropdown-item">
              {{ option.value }}
            </li>
          }
          @if (isLoadingMore) {
            <li class="dropdown-item text-center p-2">
              <loader [config]="dropdownLoaderConfig"/>
            </li>
          }
        </ul>
      }
    </div>
    @if (inputFormControl && inputFormControl.invalid && (inputFormControl.touched || inputFormControl.dirty)) {
      <div class="invalid-feedback">
        @if (inputFormControl.errors?.['required']) {
          <span><i class="fa fa-exclamation-circle me-1"></i>Required field</span>
        }
        @if (inputFormControl.errors?.['minlength']) {
          <span><i class="fa fa-exclamation-circle me-1"></i>At least 3 characters required.</span>
        }
        @if (inputFormControl.errors?.['pattern']) {
          <span><i class="fa fa-exclamation-circle me-1"></i>Invalid format.</span>
        }
        @if (inputFormControl.errors?.['backendError']) {
          <span><i class="fa fa-exclamation-circle me-1"></i>{{ inputFormControl.errors?.['backendError'] }}</span>
        }
      </div>
    }
  </div>
</div>
